import { EuroCircleOutlined, HomeOutlined, LineChartOutlined, SearchOutlined, ToolOutlined } from '@ant-design/icons'
import { Layout, Menu } from 'antd'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { COLOR } from '../../constants'
import Logo from './Logo'
const { Sider } = Layout

const StyledSider = styled(Sider)`
  height: 100%;
  position: fixed;
  left: 0;
  background-color: var(--darkest-grey);
  /* color: #eee; */

  .ant-layout-sider-children {
    width: calc(100% - 1px) !important;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .submenu-item-bg-color {
    background-color: var(--darkest-grey);
  }

  .ant-menu {
    color: #eee;
    background-color: var(--darkest-grey);
  }

  .ant-layout-sider-trigger {
    background-color: var(--darkest-grey);
  }
  .ant-menu-inline-collapsed {
    width: 50px;
  }

  .ant-menu-submenu.ant-menu-submenu-inline {
    color: #eee;
    width: calc(100% + 1px) !important;
    background-color: var(--darkest-grey);
  }

  .ant-menu-submenu-title {
    color: #eee;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    border-right: 0px var(--light-grey) !important;
  }

  // ICON ARROW
  .ant-menu-submenu-arrow {
    color: white;
  }
  .ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-selected .ant-menu-submenu-arrow {
    /* color: black; */
    color: ${COLOR.green};
  }
  // ICON ARROW

  .ant-menu-item {
    color: #eee;
    background-color: var(--darkest-grey);
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  // MENU CHILD
  .ant-menu-item.ant-menu-item-only-child {
    padding-left: 30px !important;
    background-color: var(--light-grey);
  }
  // MENU CHILD

  // SELECTED MENU ITEM
  .ant-menu-item.ant-menu-item-selected {
    color: var(--darkest-grey);
    background-color: #fff;
  }
  // ** CHILD
  .ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-selected {
    /* background-color: #fff; */
  }
  .ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-selected .ant-menu-submenu-title {
    color: ${COLOR.green};
    /* color: var(--darkest-grey); */
  }
`

// const COPRO_NAV = [
//   {
//     icon: TeamOutlined,
//     title: 'Réunions',
//     childs: [{ title: 'Assemblées Générales' }, { title: 'Réunions' }],
//   },
//   {
//     icon: MailOutlined,
//     title: 'Courriers',
//   },
//   {
//     icon: ExclamationCircleOutlined,
//     title: 'Suivi',
//     childs: [{ title: 'Demandes' }, { title: 'Dossiers' }, { title: 'Sinistres' }, { title: 'Interventions' }],
//   },
//   {
//     icon: FileOutlined,
//     title: 'Documents',
//     childs: [{ title: 'Factures' }, { title: 'Devis' }, { title: 'Contrats' }],
//   },
// ]

const GESTIONNAIRE_NAV = [
  {
    icon: ToolOutlined,
    title: 'Outils',
    childs: [
      {
        path: '/legacy/conception_panneau_bal_interphone.jsp',
        title: 'Panneau BAL / Interphone',
      },
      { path: '/mails/', title: 'Mails' },
      { path: '/legacy/FichesFournisseurs/', title: 'Fiches fournisseurs' },
      { path: '/legacy/factures_au_visa_d4_2.jsp', title: 'Validation des factures' },
      { path: '/legacy/gestion_courriers_entrants_2.jsp', title: 'Gestion courriers entrants' },
      { path: '/legacy/v2/gestion_rappels.jsp', title: 'Gestion des Rappels' },
      { path: '/legacy/planif_ag_semaine.jsp', title: 'Planification AG' },
      { path: '/legacy/controle_dates_contrats.jsp', title: 'Dates des contrats' },
      { path: '/rar/valider', title: 'Saisir les RAR' },
      { path: '/demandes/rappels', title: 'Demandes de rappels' },
      { path: '/sms/recouvrements', title: 'Recouvrements' },
      { path: '/rh', title: 'RH' },
      { path: '/charts', title: 'Charts' },
      { path: '/notes', title: 'Notes' },
    ],
  },
  {
    icon: LineChartOutlined,
    title: 'Indicateurs',
    childs: [
      { path: '/legacy/stats.jsp', title: 'Statistiques Copro' },
      { path: '/legacy/audit/accueil_stats.jsp', title: 'Mes stats' },
      { path: '/legacy/v2/controle_rappels.jsp', title: 'Contrôles Rappels' },
      { path: '/legacy/audit/audit_reunions_gestionnaire.jsp', title: 'Contrôles Réunions' },
    ],
  },
  {
    icon: SearchOutlined,
    title: 'Recherche',
    childs: [
      { path: '/legacy/gestion_ouvrants.jsp', title: "Codes d'accès" },
      { path: '/legacy/liste_coproprietaires_lots.jsp', title: 'Copropriétaires / Lots' },
    ],
  },
  {
    icon: EuroCircleOutlined,
    title: 'Compta',
    childs: [
      { path: '/legacy/gestion_rejets_prelevement.jsp', title: 'Gestion des rejets' },
      { path: '/legacy/v2/envoi_fichiers_mutation.jsp', title: 'Mail mutation' },
    ],
  },
]

const LeftSider = ({ collapsed, onCollapse }: { collapsed: boolean; onCollapse: (collapsed: boolean) => void }) => {
  const { push } = useHistory()

  return (
    <StyledSider
      breakpoint="xl"
      collapsedWidth="0"
      collapsible
      onCollapse={onCollapse}
      zeroWidthTriggerStyle={{
        position: 'absolute',
        top: collapsed ? 5 : 13,
        right: collapsed ? -40 : 20,
        backgroundColor: collapsed ? 'white' : COLOR.darkestGrey,
        color: collapsed ? 'black' : '',
        // height: 50,
      }}
    >
      <Logo collapsed={collapsed} />
      <Menu theme="light" mode="inline" defaultSelectedKeys={['4']}>
        <Menu.Item key="Accueil" icon={<HomeOutlined />} onClick={() => push('/')}>
          Accueil Vision
        </Menu.Item>
        {GESTIONNAIRE_NAV.map((path) => {
          if (path.childs) {
            return (
              <Menu.SubMenu key={path.title} icon={<path.icon />} title={path.title}>
                {path.childs.map((child) => (
                  <Menu.Item key={child.title} onClick={() => push(child.path)}>
                    {child.title}
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            )
          }
        })}
        {/* <Menu.SubMenu key="Réunions" icon={<TeamOutlined />} title="Réunions">
          <Menu.Item key="ag">Assemblées Générales</Menu.Item>
          <Menu.Item key="réu-sub">Réunions</Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu key="4" icon={<ExclamationCircleOutlined />} title="Suivi">
          <Menu.Item key="Demandes">Demandes</Menu.Item>
          <Menu.Item key="Dossiers">Dossiers</Menu.Item>
          <Menu.Item key="Sinistres">Sinistres</Menu.Item>
          <Menu.Item key="Interventions">Interventions</Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu key="Documents" icon={<FileOutlined />} title="Documents">
          <Menu.Item key="Factures">Factures</Menu.Item>
          <Menu.Item key="Devis">Devis</Menu.Item>
          <Menu.Item key="Contrats">Contrats</Menu.Item>
        </Menu.SubMenu> */}
      </Menu>
    </StyledSider>
  )
}

export default LeftSider
